import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-book-open-line text-background-50 text-base"></i>
              </div>
              <span className="text-lg font-bold font-heading text-primary-600">亲亲漫画</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              亲亲漫画网致力于为广大漫画爱好者提供海量免费韩国漫画、日本漫画和国产漫画资源。下拉式流畅阅读体验，无删减完整版内容，让阅读更畅快。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">首页</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">关于我们</Link>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">读者协议</a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">隐私政策</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2 text-sm text-foreground-600">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-mail-line text-foreground-400"></i>
                </div>
                <span>contact@yutuocq.cn</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-600">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-customer-service-line text-foreground-400"></i>
                </div>
                <span>客服QQ：1234567890</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-600">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-time-line text-foreground-400"></i>
                </div>
                <span>工作时间：9:00 - 21:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; 2026 亲亲漫画网 yutuocq.cn 版权所有 | 本站所有漫画均来自互联网，版权归原作者所有
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-foreground-400 hover:text-primary-500 transition-colors" aria-label="微博">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-weibo-line text-lg"></i>
                </div>
              </a>
              <a href="#" className="text-foreground-400 hover:text-primary-500 transition-colors" aria-label="微信">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-wechat-line text-lg"></i>
                </div>
              </a>
              <a href="#" className="text-foreground-400 hover:text-primary-500 transition-colors" aria-label="QQ">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-qq-line text-lg"></i>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}